import {useIntl} from 'react-intl';
import {Phone} from 'lucide-react';
import type {CallLine} from '../model/types';
import {phoneMessages as m} from './phoneMessages';
import {lineTextOf} from './phoneText';

export const LineChip = ({line, incoming = false, size = 'bubble'}: {line: CallLine; incoming?: boolean; size?: 'bubble' | 'stage'}) => {
    const intl = useIntl();
    const text = incoming ? intl.formatMessage(m.toLine, {line: lineTextOf(line)}) : lineTextOf(line);
    return (
        <span
            data-testid="phone-call-line"
            className={size === 'stage'
                ? 'inline-flex h-7 max-w-full items-center gap-2 rounded-full bg-[var(--phq-call-surface)] px-3 text-[13px] font-semibold text-[var(--phq-call-ink-muted)]'
                : 'inline-flex h-6 min-w-0 max-w-full items-center gap-1.5 overflow-hidden whitespace-nowrap rounded-lg bg-[var(--phq-call-surface)] px-2 text-xs font-semibold text-[var(--phq-call-ink-muted)]'}
        >
            <Phone size={size === 'stage' ? 14 : 13} className="shrink-0" aria-hidden="true"/>
            <span className="truncate tabular-nums">{text}</span>
        </span>
    );
};

export const RecordingChip = () => {
    const intl = useIntl();
    return (
        <span data-testid="phone-call-recording" className="inline-flex h-6 shrink-0 items-center gap-1.5 whitespace-nowrap rounded-lg bg-[var(--phq-call-recording-bg)] px-2 text-xs font-semibold text-[var(--phq-call-recording-ink)]">
            <span aria-hidden="true" className="h-2 w-2 rounded-full bg-[var(--phq-call-recording-dot)]"/>
            {intl.formatMessage(m.recording)}
        </span>
    );
};

export const UnknownNumberPill = () => {
    const intl = useIntl();
    return (
        <span data-testid="phone-call-unknown" className="mt-0.5 inline-flex h-6 items-center rounded-lg bg-[var(--phq-call-surface-muted)] px-2 text-xs font-semibold text-[var(--phq-call-ink-muted)]">
            {intl.formatMessage(m.unknownNumber)}
        </span>
    );
};

export const SpamPill = () => {
    const intl = useIntl();
    return (
        <span data-testid="phone-call-spam" className="mt-0.5 inline-flex h-6 items-center rounded-lg bg-[var(--phq-call-warning-note)] px-2 text-xs font-semibold text-[var(--phq-call-warning-ink)]">
            {intl.formatMessage(m.likelySpam)}
        </span>
    );
};
